export const TECHPOINT_MMS = "/techpoint-general-mms/api";
export const TECHPOINT_BUSINESS_MMS = "/techpoint-business-mms/api";
